module.exports = __webpack_public_path__ + "img/blueperks_logo.7d6110d0.png";